import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import LandingPage from "@/pages/LandingPage";
import SpeechForm from "@/pages/SpeechForm";
import PreviewPage from "@/pages/PreviewPage";
import SuccessPage from "@/pages/SuccessPage";
import PricingPage from "@/pages/PricingPage";
import ExamplesPage from "@/pages/ExamplesPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import BlogPage, { BlogPostPage } from "@/pages/BlogPage";
import LoginPage from "@/pages/LoginPage";
import MySpeechesPage from "@/pages/MySpeechesPage";
import BrandGalleryPage from "@/pages/BrandGalleryPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ContactPage from "@/pages/ContactPage";
import CookieBanner from "@/components/CookieBanner";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Blog post wrapper to extract postId from URL
function BlogPostWrapper() {
  const { postId } = useParams();
  return <BlogPostPage postId={postId} />;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <ScrollToTop />
          <CookieBanner />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/tale" element={<SpeechForm />} />
              <Route path="/preview" element={<PreviewPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/priser" element={<PricingPage />} />
              <Route path="/eksempler" element={<ExamplesPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:postId" element={<BlogPostWrapper />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/mine-taler" element={<MySpeechesPage />} />
              <Route path="/handelsbetingelser" element={<TermsPage />} />
              <Route path="/privatlivspolitik" element={<PrivacyPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/brand/galleri" element={<BrandGalleryPage />} />
            </Route>
            {/* Admin routes — no Layout (no public header/footer) */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
